export { WebVitalsInstrumentation } from './instrumentation';
